import { DestroyRef, inject, Injectable, Signal, signal } from '@angular/core';
import { ConnectionService } from 'ng-connection-service';
import { ToastrService } from 'ngx-toastr';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { debounceTime } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class ConnectivityMonitorService {
  private destroyRef = inject(DestroyRef);
  private isConnectedSignal = signal<boolean>(navigator.onLine);
  private isOffline = false;
  private connectionService = inject(ConnectionService);
  private toast = inject(ToastrService);

  constructor() {
    this.connectionService.monitor().pipe(
      debounceTime(500),
      takeUntilDestroyed(this.destroyRef)
    ).subscribe((isConnected) => {
      this.isConnectedSignal.set(isConnected.hasNetworkConnection);
      this.handleConnectionToast(isConnected.hasNetworkConnection);
    });
  }

  public get connectionStatus(): Signal<boolean> {
    return this.isConnectedSignal.asReadonly();
  }

  public get isConnected(): boolean {
    return this.isConnectedSignal();
  }

  private handleConnectionToast(isConnected: boolean) {
    if (isConnected && this.isOffline) {
      this.toast.clear();
      this.toast.success('You are back online!', '', {
        timeOut: 6000,
        positionClass: 'toast-top-right',
        easing: 'ease-in-out',
        closeButton: true,
        toastClass: 'ngx-toastr',
      });
      this.isOffline = false;
    } else if (!isConnected && !this.isOffline) {
      this.toast.error('You are offline!', '', {
        disableTimeOut: true,
        positionClass: 'toast-top-right',
        easing: 'ease-in-out',
        closeButton: true,
        toastClass: 'ngx-toastr',
      });
      this.isOffline = true;
    }
  }
}
